// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2l__t","validationTips":"StatementDescriptor_validationTips__2x2Gd"};